<template>
  <div>
    <van-uploader
      :after-read="afterRead"
      :preview-image="previewImage"
      :multiple="multiple"
      v-model="picList"
      :max-count="maxSize"
      :preview-size="previewSize"
      @delete="deleteImg"
    >
      <slot></slot>
    </van-uploader>
  </div>
</template>

<script>
  import api from 'api/oss';
  import axios from 'axios';
  function getFileKey(dir,file) {
    let randomNum = Math.random().toString().replace(".", "");
    return dir + randomNum +'.'+ file.type.split('/')[1];
  }
  export default {
    props:{
      maxSize:{
        type: Number,
        default: 10
      },
      multiple:{
        type: Boolean,
        default: false
      },
      previewImage: {
        type: Boolean,
        default: true
      },
      previewSize: {
        type: Number,
        default: 80
      }
    },
    data(){
      return {
        ossParams:{},
        uploadUrl:'',
        ossurl: 'https://ovopark.oss-cn-hangzhou.aliyuncs.com',
        picList:[]
      }
    },
    created() {
      this.fetchOssParams()
    },
    methods:{
      //获取上传oss所需要的参数
      async fetchOssParams(){
        const {data} = await api.getOssParams();
        let params = JSON.parse(data);
        this.ossParams.policy = params.policy;
        this.ossParams.signature = params.signature;
        this.ossParams.dir = params.dir;
        this.ossParams.OSSAccessKeyId = params.accessid;
        this.uploadUrl = params.host;
      },
      afterRead(data) {
        let fileArr = [];
        if (Array.isArray(data)) {
          fileArr = data;
        }else{
          fileArr = [data];
        }
        fileArr.map(item=>{
          let that = this;
          let key = getFileKey(this.ossParams.dir, item.file);
          const formData = new FormData();
          formData.set('key', key);
          formData.set('policy', this.ossParams.policy);
          formData.set('OSSAccessKeyId', this.ossParams.OSSAccessKeyId);
          formData.set('signature', this.ossParams.signature);
          formData.set('file', item.file);
          axios({
            method: 'post',
            url: that.ossurl,
            data: formData,
            responseType: 'string',
          }).then(() => {
            let url = this.ossurl + '/' + key;
            this.picList.map(pic=>{
              if (pic.file.name === item.file.name ){
                pic.url = url;
              }
            })
            this.$emit('getImage',this.picList)
            console.log(this.picList);
          })
        })
      },
      deleteImg(data) {
        console.log(this.picList);
        console.log(data);
        this.$emit('getImage',this.picList)
      }
    }
  }
</script>

<style scoped>

</style>